import {EventPersistor, Event} from '@deckmans/domain';
import {MyDatabase} from 'contexts/IndexedDbContext';

export class IndexedDbEventPersistor implements EventPersistor {
  constructor(private db: MyDatabase) {}
  async persist(event: Event): Promise<void> {
    await this.db.persistEvent(event);
  }
}
